import { Position } from "react-flow-renderer";
export const config = {
    styles: {
      wrapper: {
        default: {
          backgroundColor: "#FFFFFF",
          borderColor: "#FE7920",
        },
        selected: {
          backgroundColor: "#FE7920",
        },
      },
      label: {
        default: {
          color: "#333533",
        },
        selected: {
          color: "#FFFFFF",
        },
      },
      body: {
        default: {
          color: "#333533",
        },
        selected: {
          color: "#FFFFFF",
        },
      },
    },
    handleStyles: [
      {
        properties: {
          type: "target",
          position: Position.Top,
        },
        style: {
          backgroundColor: "blue",
          top: "-15px",
        },
      },
      {
        properties: {
          id: "decision-node-output",
          type: "source",
          position: Position.Bottom,
        },
        style: { backgroundColor: "green", bottom: "-15px" },
      },
    ],
  };